import { render, staticRenderFns } from "./AppCombobox.vue?vue&type=template&id=5363377c&"
import script from "./AppCombobox.vue?vue&type=script&lang=ts&"
export * from "./AppCombobox.vue?vue&type=script&lang=ts&"
import style0 from "./AppCombobox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
